import {certapplyConstants} from '../../constants'

export const initialState = {
  data: {
    step1: {},
    step2: [],
    step3: [],
    step4: [],
  },
  isOpen: false,
  isType: false,
  guideType: 'individual',
  currentStep: '1',
  isCalled: false,
  isShowItems: false,
  isFailure: false,
  isSend: false,
  itemSeq: '',
}

export default function certapply(state = initialState, action) {
  switch (action.type) {
    /********************
     진행단계 변경
     ********************/
    case certapplyConstants.STEP_SAVE:
      return {
        ...state,
        currentStep: action.step,
      }
    /********************
     구매확인서 임시저장
     ********************/
    case certapplyConstants.TEMP_SAVE_REQUEST:
      return {
        ...state,
        isCalled: false,
        isFailure: false,
      }
    case certapplyConstants.TEMP_SAVE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ["step" + state.currentStep] : action.docInfo,
        },
        isCalled: true,
        isFailure: false,
      }
    case certapplyConstants.TEMP_SAVE_SUCCESS_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          ["step" + action.step] : action.list,
        },
        isCalled: true,
        isFailure: false,
      }
    case certapplyConstants.TEMP_SAVE_FAILURE:
      return {
        ...state,
        isCalled: true,
        isFailure: true,
      }
    case certapplyConstants.RESET_CALLED:
      return {
      ...state,
        isCalled: action.called,
      }
    case certapplyConstants.SET_STEP_DATA:
      return {
        ...state,
        data : {
          ...state.data,
          ["step" + action.step] : action.stepInfo
        },
      }
    /********************
     구매확인서 문서번호 채번
     ********************/
    case certapplyConstants.GET_DOCNUM_REQUEST :
      return {
        ...state
      }
    case certapplyConstants.GET_DOCNUM_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          step1: action.response.data?.payload,
        },
      }
    case certapplyConstants.GET_DOCNUM_FAILURE:
      return {
        ...state,
        data: null,
      }
    /********************
     구매확인서 저장정보 조회
     ********************/
    case certapplyConstants.GET_CONFIRMATION_REQUEST :
      return {
        ...state
      }
    case certapplyConstants.GET_CONFIRMATION_SUCCESS:
      let obj = action.response.data?.payload;
      return {
        ...state,
        data: {
          step1: obj?.crtIssueMasterDto ? obj?.crtIssueMasterDto : {},
          step2: obj?.crtConfirmationItemDtoList ? obj?.crtConfirmationItemDtoList : [],
          step3: obj?.crtConfirmationFileDtoList ? obj?.crtConfirmationFileDtoList : [],
          step4: obj?.crtConfirmationTaxDtoList ? obj?.crtConfirmationTaxDtoList : [],
        },
      }
    case certapplyConstants.GET_CONFIRMATION_FAILURE:
      return {
        ...state,
        data: null,
      }
    /********************
     구매확인서 임시저장정보 삭제
     ********************/
    case certapplyConstants.TEMP_DELETE_REQUEST :
      return {
        ...state,
        isDelete: false,
      }
    case certapplyConstants.TEMP_DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    case certapplyConstants.TEMP_DELETE_FAILURE:
      return {
        ...state,
        data: null,
        isDelete: false,
      }
    /********************
     구매확인서 발급신청
     ********************/
    case certapplyConstants.ISSUE_REQUEST :
      return {
        ...state,
        isSend:false,
      }
    case certapplyConstants.ISSUE_SUCCESS:
      return {
        ...state,
        isSend:true,
      }
    case certapplyConstants.ISSUE_FAILURE:
      return {
        ...state,
        isSend:false,
      }
    /**
     * 팝업 화면 표시용
     */
    case certapplyConstants.CERTAPPLY_REQUEST:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case certapplyConstants.SHOW_POPUP_ITEMS:
      return {
        isShowItems: action.isShow,
        itemSeq: '',
      }
    case certapplyConstants.SELECT_POPUP_ITEMS:
      return {
        itemSeq: action.itemSeq,
        isShowItems: false,
      }
    case certapplyConstants.CERTAPPLY_SUCCESS:
      return {
        ...state,
        isType: !state.isType
      }
    case certapplyConstants.CERTAPPLY_TOGGLE_TYPE:
      return {
        ...state,
        isType: !state.isType
      }
    case certapplyConstants.CERTAPPLY_CLOSE:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case certapplyConstants.CERTAPPLY_GUIDE_TYPE:
      return {
        ...state,
        guideType: action.guideType
      }

    /***********
     상태관련 state 초기화
     ************/
    case certapplyConstants.CLEAR_REQUEST:
      return {
        ...state,
	  isSend: false,
      }

    /*********
    주문서
     **********/
    case certapplyConstants.ISSUED_ORDER_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certapplyConstants.ISSUED_ORDER_SUCCESS:
      return {
        ...state,
        issuedOrderInfo: action.response.data?.payload,
        isDelete: false,
      }
    case certapplyConstants.ISSUED_ORDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /*********
    결제 승인
    **********/
    case certapplyConstants.ORDER_RESULT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certapplyConstants.ORDER_RESULT_SUCCESS:
      return {
        ...state,
        OrderResult: action.response,
        isDelete: false,
      }
    case certapplyConstants.ORDER_RESULT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /********************
     구매확인서 PDF 파일생성
     ********************/
    case certapplyConstants.TEMP_PDF_REQUEST:
      return {
        ...state,
        isPdf: false,
      }
    case certapplyConstants.TEMP_PDF_SUCCESS:
      return {
        ...state,
        isPdf: true,
      }
    case certapplyConstants.TEMP_PDF_FAILURE:
      return {
        ...state,
        data: null,
        isPdf: false,
      }
      
    /*********
    결제 취소
    **********/
    case certapplyConstants.CANCEL_RESULT_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certapplyConstants.CANCEL_RESULT_SUCCESS:
      return {
        ...state,
        CancelResult: action.response,
        isDelete: false,
      }
    case certapplyConstants.CANCEL_RESULT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }
    default:
      return state
  	}
	

}
